module.exports = __webpack_public_path__ + "img/Asahi-World-Forum-967x683.f8b22129.png";